import { render } from "./user-date.vue?vue&type=template&id=79fe738c&lang=pug"
import script from "./user-date.vue?vue&type=script&lang=js"
export * from "./user-date.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__